/* eslint-disable */

import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Input, Button, Typography, Select } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import CustomPasswordTooltip from 'components/CustomPassowrdTooltip/CustomPassowrdTooltip';
import { previousValidatePassword } from 'components/CommonValidations/CommonValidations';
import { SUBMERCHANT_BUSINESS_ENTITY, SUBMERCHANT_STATE } from '../const';
import './index.scss';

function SubmerchantSignupForm({
  submerchantSignUpForm,
  handleFormSubmit,
  submitButtonDisable,
  recaptchaRef
}) {
  const [submerchantPasswordTooltipOpen, setSubmerchantPasswordTooltipOpen] = useState(false);

  return (
    <Form
      form={submerchantSignUpForm}
      layout="vertical"
      onFinish={handleFormSubmit('submerchant')}
      autoComplete="off"
    >
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            name="sub_merchant_name"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Submerchant Name</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter name' },
              {
                pattern: /^[a-zA-Z0-9]+[a-zA-Z0-9 .&-]*[a-zA-Z0-9\.\-\&]+$/,
                message: 'Invalid name format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter name" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_account_number"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>
                  Submerchant Account No
                </Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter account number' },
              { pattern: /^[A-Za-z0-9]{5,20}$/, message: 'Invalid account number format' }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter account number" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_email"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Submerchant Email</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Invalid email format' }
            ]}
          >
            <Input
              style={{ width: '100%', padding: '12px' }}
              placeholder="Enter email"
              autoComplete="off"
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_bank_name"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>
                  Submerchant Bank name
                </Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter bank name' },
              {
                pattern: /^[a-zA-z0-9]+[a-zA-z0-9 -]*[a-zA-z0-9]+$/,
                message: 'Invalid bank name format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter bank name" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_phone"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Submerchant Phone</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter phone' },
              { pattern: /^(\+\d{1,3}[-]?)?\d{5,20}$/, message: 'Invalid phone format' }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter phone" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_branch_name"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>
                  Submerchant Bank Branch
                </Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter branch name' },
              {
                pattern: /^[a-zA-z0-9]+[a-zA-z0-9 ,-;]*[a-zA-z0-9]+$/,
                message: 'Invalid branch name format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter branch name" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_name_in_bank"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>
                  Submerchant's Name in Bank
                </Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter name in bank' },
              {
                pattern: /^[a-zA-Z0-9]+(|(['"]{{1}}[a-zA-Z0-9]+)|([ ]+[a-zA-Z0-9])+).*/,
                message: 'Invalid name format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter name in bank" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_ifsc_code"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>
                  Submerchant's IFSC code
                </Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter IFSC code' },
              {
                pattern: /^[A-Z|a-z]{4}[0][\d | A-Z|a-z]{6}$/,
                message: 'Invalid IFSC code format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter IFSC code" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_business_name"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Business Name</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter business name' },
              {
                pattern: /^[a-zA-z0-9]+[a-zA-Z0-9 .]*[a-zA-z0-9]+$/,
                message: 'Invalid business name format'
              }
            ]}
          >
            <Input style={{ width: '100%', padding: '12px' }} placeholder="Enter business name" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="sub_merchant_business_address"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Business Address</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[{ required: true, message: 'Please enter business address' }]}
          >
            <Input
              style={{ width: '100%', padding: '12px' }}
              placeholder="Enter business address"
            />
          </Form.Item>
        </Col>

        <Col span={12} className="submerchant-form">
          <Form.Item
            name="sub_merchant_state"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>State</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter state' },
              {
                pattern: /^[a-zA-z0-9]+[a-zA-Z0-9\-._&%^ ]*[a-zA-z0-9]+$/,
                message: 'Invalid state format'
              }
            ]}
          >
            <Select
              showSearch
              size="large"
              placeholder="Select state"
              optionFilterProp="label"
              options={SUBMERCHANT_STATE}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>

        <Col span={12} className="submerchant-form">
          <Form.Item
            name="sub_merchant_business_entity"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Business Entity</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[
              { required: true, message: 'Please enter business entity' },
              { pattern: /^[a-zA-Z0-9\-._/() –—]+$/, message: 'Invalid business entity format' }
            ]}
          >
            <Select
              size="large"
              placeholder="Select business entity"
              options={SUBMERCHANT_BUSINESS_ENTITY}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            name="sub_merchant_password"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Create Password</Typography.Text>
                <span className="required-mark" />
              </>
            }
            rules={[{ required: true, message: 'Please enter password' }]}
          >
            <CustomPasswordTooltip
              placeholder="Enter Password"
              datakey="sub_merchant_password"
              formData={submerchantSignUpForm}
              setTooltipOpen={setSubmerchantPasswordTooltipOpen}
              tooltipOpen={submerchantPasswordTooltipOpen}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            name="sub_merchant_confirm_password"
            label={
              <>
                <Typography.Text style={{ fontSize: '16px' }}>Confirm Password</Typography.Text>
                <span className="required-mark" />
              </>
            }
            dependencies={['sub_merchant_password']}
            validateTrigger="onChange"
            rules={[
              { required: true, message: 'Please confirm password' },
              ({ getFieldValue }) => ({
                validator: (_, value) =>
                  previousValidatePassword(value, getFieldValue('sub_merchant_password'))
              })
            ]}
          >
            <Input.Password
              placeholder="Enter Confirm Password"
              style={{ width: '100%', padding: '12px' }}
              size="middle"
              autoComplete="off"
            />
          </Form.Item>
        </Col>

        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        />

        <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={submitButtonDisable}>
              Submit
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

SubmerchantSignupForm.propTypes = {
  submerchantSignUpForm: PropTypes.instanceOf(Object).isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  submitButtonDisable: PropTypes.bool.isRequired,
  recaptchaRef: PropTypes.instanceOf(Object).isRequired
};
export default SubmerchantSignupForm;
